import { type FC, memo, useCallback } from 'react';
import { Box, type BoxProps } from '@mui/joy';

import { useNavigate } from 'navigation/hooks';
import { useDispatcher } from 'store/utils/redux/hooks';
import useMyLibrary from 'screens/Space/model/useMyLibrary';

import InfoButton, { type InfoButtonProps } from './InfoButton';

interface InfoToolbarProps extends BoxProps {}

const InfoToolbar: FC<InfoToolbarProps> = (props) => {
  const dispatcher = useDispatcher();

  const navigate = useNavigate();
  const myLibrary = useMyLibrary();

  const handleInfoClick = useCallback<NonNullable<InfoButtonProps['onClick']>>(
    (event, itemId) => {
      if (itemId === 'newDocument') {
        navigate('Note', {
          id: `${myLibrary.spaceId}::${myLibrary.entityId}::create`,
        });
      }
      if (itemId === 'newKnowledge') {
        dispatcher.plus.open();
      }
      if (itemId === 'newSpace') {
        dispatcher.modal.open('SpaceManageData', { mode: 'create' });
      }
      if (itemId === 'newFolder') {
        const addAction = document.querySelector(`[itemid="${myLibrary.spaceId}::space::addAction"]`) as HTMLDivElement | null;
        if (!addAction) {
          return;
        }
        addAction.click();
      }
      if (itemId === 'getExtension') {
        const link = document.createElement('a');
        link.setAttribute('href', 'https://chrome.google.com/webstore/detail/ikiai-your-knowledge-hub/bjdlhnaghjcjihjiojhpnimlmfnehbga');
        link.setAttribute('target', '_blank');
        link.click();
      }
    },
    [navigate, myLibrary],
  );

  return (
    <Box display="flex" flexDirection="row" justifyContent="center" alignSelf="center" gap={1.5} pt="1.5vh" {...props}>
      <InfoButton
        itemID="newDocument"
        onClick={handleInfoClick}
        label="New document"
        iconFamily="kit"
        iconName="light-file-pen"
        description="Write with  your library co-pilot"
        flex={1}
      />
      <InfoButton
        itemID="newKnowledge"
        onClick={handleInfoClick}
        label="Add Knowledge"
        iconName="plus"
        description="Add one or many links  or upload PDF, TXT, images to your library"
        flex={1}
      />
      <InfoButton
        itemID="newSpace"
        onClick={handleInfoClick}
        label="New Space"
        iconName="users-medical"
        description="Create a new space  and collaborate with your team"
        flex={1}
      />
      <InfoButton
        itemID="newFolder"
        onClick={handleInfoClick}
        label="New collection"
        iconName="folder-plus"
        description="Create a new collection  with a dedicated assistant"
        flex={1}
      />
      <InfoButton
        itemID="getExtension"
        onClick={handleInfoClick}
        label="Browser extension"
        iconName="puzzle-piece"
        description="Download browser extension  to save webpages along with highlights and notes"
        flex={1}
      />
    </Box>
  );
};

export default memo(InfoToolbar);
